import api from '@/api/graphql/learning';
import * as types from './types';

const format = text => text
  .replace(/</g, '&#60;') // high
  .replace(/\n/g, '<br />')
  .replace(/([A-z])\^(\(([\d|A-z])+\))/g, '$1<sup>$3</sup>');

export default {
  state: {
    courseList: [],
    currentCourse: {},
    courseData: {},
    firstLogin: 0,
  },
  getters: {
    [types.COURSE_LIST]: state => state.courseList,
    [types.COURSE_DATA]: state => state.courseData,
    [types.CURRENT_COURSE]: state => state.currentCourse,
    [types.FIRST_LOGIN]: state => state.firstLogin,
  },
  mutations: {
    [types.COURSE_LIST]: (state, payload) => {
      state.courseList = payload.courseList;
    },
    [types.COURSE_DATA]: (state, payload) => {
      state.courseData = payload.courseData;
    },
    [types.CURRENT_COURSE]: (state, payload) => {
      state.currentCourse = payload.currentCourse;
    },
    [types.CANCEL_LAST_TIME_LEARNED]: (state) => {
      state.courseData.isBacktrack = 0;
    },
    [types.FIRST_LOGIN]: (state, payload) => {
      state.firstLogin = payload;
    },
  },
  actions: {
    [types.FETCH_COURSE_LIST]: async ({ commit }) => {
      const { courses } = await api.getCourseList();
      commit(types.COURSE_LIST, {
        courseList: courses,
      });
      return {
        courseList: courses,
      };
    },
    [types.FETCH_COURSE_DATA]: async ({ commit }, payload) => {
      const { courseData } = await api.getCourseData({
        courseId: payload.courseId,
        type: payload.type,
        action: payload.action,
        chapterId: payload.chapterId,
        sectionId: payload.sectionId,
        id: payload.id || 0,
      });
      // format
      courseData.quizzes.forEach((item) => {
        if (item.text) {
          item.text = format(item.text);
        }
        if (item.explain) {
          item.explain = format(item.explain);
        }
        if (item.question) {
          item.question = format(item.question);
        }
        if (item.title) {
          item.title = format(item.title);
        }
        if (item.options && item.options.length) {
          for (let i = 0; i < item.options.length; i += 1) {
            item.options[i] = format(item.options[i]);
          }
        }
      });
      commit(types.COURSE_DATA, { courseData });
      return {
        courseData,
      };
    },
    [types.SUBMIT_COURSE_RESULT]: async (context, payload) => {
      const { courseResult } = await api.submitCourseResult({
        id: payload.id,
        courseId: payload.courseId,
        seconds: payload.seconds || 0,
        quizzes: payload.quizzes,
        type: payload.type,
        isBacktrack: payload.isBacktrack,
      });
      return {
        score: courseResult.score,
      };
    },
  },
};
